import { Fragment } from "react";
import ButtonFields from "./button-fields.component";

const ThreeStateButtons = ({
  isQuoteEdit,
  isQuoteLoaded,
  addButtons,
  handlers: {
    handleAdd,
    handleClear,
    handleEdit,
    handleNew,
    handleCancel,
    handleSave,
    handleCopy,
  },
}) => {
  return (
    <Fragment>
      {!isQuoteLoaded ? (
        <Fragment>
          <ButtonFields
            constants={addButtons.clear}
            handler={handleClear}
            disabled={false}
            min={true}
          />
          <ButtonFields
            constants={addButtons.add}
            handler={handleAdd}
            disabled={false}
            min={true}
          />
        </Fragment>
      ) : null}
      {isQuoteLoaded & !isQuoteEdit ? (
        <Fragment>
          <ButtonFields
            constants={addButtons.new}
            handler={handleNew}
            disabled={false}
            min={true}
          />
          <ButtonFields
            constants={addButtons.edit}
            handler={handleEdit}
            disabled={false}
            min={true}
          />
          <ButtonFields
            constants={addButtons.copy}
            handler={handleCopy}
            disabled={false}
            min={true}
          />
        </Fragment>
      ) : null}
      {isQuoteLoaded & isQuoteEdit ? (
        <Fragment>
          <ButtonFields
            constants={addButtons.cancel}
            handler={handleCancel}
            disabled={false}
            min={true}
          />
          <ButtonFields
            constants={addButtons.save}
            handler={handleSave}
            disabled={false}
            min={true}
          />
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default ThreeStateButtons;
